import { toast } from '@krakentech/coral';

import { useForceReauthentication } from '@/hooks/auth/useForceReauthentication';
import { useSyncFeatureFlag } from '@/hooks/utils/useFeatureFlags';
import { FeatureNames } from '@/types/features';
import { isStw } from '@/utils/environment';

const nectarEndpoint = process.env.NEXT_PUBLIC_NECTAR_ENDPOINT || '';

export const logoutNectar = async () => {
  try {
    await fetch(nectarEndpoint, {
      method: 'GET',
      credentials: 'include',
    });
  } catch {
    return;
  }
};

export const useLogout = () => {
  const displayError = () => {
    toast('There was a problem logging you out, please try again', {
      type: 'error',
    });
  };
  const { mutate, isPending } = useForceReauthentication({ displayError });
  const enabledNectarConnect = useSyncFeatureFlag(FeatureNames.NectarConnect);

  const logout = () => {
    mutate({
      input: {
        includeThirdParties: true,
      },
    });

    if (enabledNectarConnect && isStw()) {
      logoutNectar();
    }
  };

  return { logout, isPending };
};
